<template>
    <footer v-if="!isKeyboardOpen">
        <span>💻 with ❤️ &amp; <a href="//vuejs.org">Vue.js</a> in Barcelona</span>
    </footer>
</template>

<script>
export default {
    name: 'app-footer',
    data() {
        return {
            isKeyboardOpen: false,
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.isKeyboardOpen = window.innerHeight < screen.height * 0.75;
        }
    }
}
</script>

<style lang="scss" scoped>
footer {
    box-sizing: border-box;
    background-color: #cfd8dc;
    bottom: 0;
    left: 0;
    padding: 1rem;
    position: relative;
    width: 100%;

    a {
        text-decoration: none;
        color: #546E7A;
    }
}
</style>